import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

export const Note = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 11px;
  color: ${COLORS.GRAY_TEXT};
  text-align: center;
  margin: 40px 0 27px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;
